<app-left-side-nav></app-left-side-nav>
<app-header></app-header>

<!-- page content area start -->
<ng-container *ngIf="!isLoading; else loadingTemplate">
  <div class="afterLoginPageContainer">
    <div class="mainContent">
      <div class="ticketDetails">
        <div class="headS d-flex justify-content-between align-items-center">
          <a class="font-weight-600" (click)="goBack()">
            <i class="fa fa-angle-left"></i> Ticket Details
          </a>
          <div *ngIf="!ticketDetails.is_entry_expired && !ticketDetails.badge_created_datetime">
            <button class="downloadBtn" (click)="downloadAsImage()">
              <i class="fa fa-download me-1"></i> Download Ticket
            </button>
          </div>
        </div>

        <div class="bodySec">
          <!-- Start Child ticket section -->
          <div class="d-flex childTkt align-items-start" style="display: none !important">
            <i class="fa fa-info-circle"></i>
            <div class="ms-2">
              <h4 class="mb-1">Please Note</h4>
              <p class="mb-0">
                Please carry the identity card and proof of age of the child. ID will be checked at the entry gate.
              </p>
            </div>
          </div>
          <!-- End -->

          <div class="firstDayTag d-flex"
            *ngIf="ticketDetails.ticket_type_code === 'first_day_single_entry' && isFirstDayTicketAndNotUsedAndNotExpired">

            <i class="fa fa-circle-info me-2"></i>
            <div>This ticket is valid only on 1st day i.e. <b>10th December</b></div>
          </div>

          <!-- Ticket expired section -->
          <div class="tktExpired" *ngIf="ticketDetails.is_entry_expired && !ticketDetails.badge_created_datetime">
            <div class="ms-2">
              <div class="d-flex align-items-start gap-2">
                <i class="fa fa-triangle-exclamation"></i>
                <h4>Your ticket has expired</h4>
              </div>
              <p class="mb-0">
                Your ticket was valid for entry on <b>10 December 2025</b>. As the date has passed, this ticket is no
                longer valid.
                You can still visit the event by upgrading this ticket or booking a new one.
              </p>
            </div>
          </div>
          <!-- End -->

          <!-- Ticket Used section -->
          <div class="usedTkt mt-2" *ngIf="ticketDetails.badge_created_datetime">
            <div class="ms-2">
              <div class="d-flex align-items-start gap-2">
                <img src="/assets/images/used-tkt.png" alt="Ticket Used" />
                <h4>Your ticket has already been used.</h4>
              </div>
              <p class="mb-0">
                Looks like this ticket was already <b>used for entry earlier.</b>
                To join the event again, please book a new ticket.
              </p>
            </div>
          </div>
          <!-- End -->



          <div #qrContainer>
            <div class="tktOuter">
              <div>
                <div class="tktS" [ngStyle]="{
                  background: ticketColorsModal[ticketDetails.ticket_type_code].ticketDetailsColorGradientBackground
                }">
                  <div class="tkthead">
                    <img src="/assets/images/logo.png" alt="Event Logo" />
                  </div>

                  <div class="userInfo">
                    <div class="d-flex align-items-center justify-content-center">
                      <div class="imgOuter">
                        <img *ngIf="ticketDetails?.image_url; else defaultImg"
                          [src]="ticketDetails.image_url + '?time=' + epoch_time"
                          onerror="this.src='/assets/images/default-profile-individual.png'" crossorigin="anonymous"
                          alt="User Image" />
                        <ng-template #defaultImg>
                          <img src="/assets/images/default-profile-individual.png" alt="Default User Image" />
                        </ng-template>
                      </div>

                      <div class="userDetails ms-2 text-start">
                        <h4 class="mb-0 fw-bold" style="
                          word-break: break-all;
                          display: -webkit-box;
                          -webkit-line-clamp: 2;
                          line-clamp: 2;
                          -webkit-box-orient: vertical;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        ">
                          <span translate="no">{{ ticketDetails.first_name }}</span>
                          <span class="ms-2" translate="no">{{ ticketDetails.last_name }}</span>
                        </h4>

                        <p class="mb-0 font-weight-600" translate="no"
                          [ngStyle]="{ color: ticketColorsModal[ticketDetails.ticket_type_code].border }">
                          {{ ticketDetails.city + ', ' + ticketDetails.state }}
                        </p>
                      </div>
                    </div>

                    <div class="typeSec"
                      *ngIf="!ticketDetails.is_entry_expired && !ticketDetails.badge_created_datetime" [ngStyle]="{
                      background: ticketColorsModal[ticketDetails.ticket_type_code].darkPrimary,
                      border: '1px solid ' + ticketColorsModal[ticketDetails.ticket_type_code].border
                    }">
                      <span translate="no">
                        <img class="me-1" [src]="ticketsImagesBeforeSelecteingc[ticketDetails.ticket_type_code].white"
                          alt="" />
                        {{ ticketDetails.app_display_name }}
                      </span>
                    </div>
                  </div>

                  <div class="qrSec">
                    <!-- Ticket expired section -->
                    <div class="expiredTkt"
                      *ngIf="ticketDetails.is_entry_expired && !ticketDetails.badge_created_datetime">
                      <img class="w-100 mt-2" src="/assets/images/ticket-expired.png" alt="Ticket Expired" />
                    </div>
                    <!-- Ticket Used section -->
                    <div class="expiredTkt" *ngIf="ticketDetails.badge_created_datetime">
                      <img class="w-100 mt-2" src="/assets/images/tkt_allready_used.png" alt="Ticket used" />
                    </div>
                    <div class="qr" *ngIf="!ticketDetails.is_entry_expired && !ticketDetails.badge_created_datetime"
                      [ngStyle]="{
                      background: ticketColorsModal[ticketDetails.ticket_type_code].qrCode,
                      border: '1px solid ' + ticketColorsModal[ticketDetails.ticket_type_code].border
                    }">

                      <div class="qrCode text-center">
                        <!-- <img class="w-100" src="/assets/images/dummy_qr.png" /> -->
                        <qrcode class="qrCode" [qrdata]="ticketCode" [width]="200" [errorCorrectionLevel]="'M'"
                          [colorDark]="'#ffffff'"
                          [colorLight]="ticketColorsModal[ticketDetails.ticket_type_code].qrCode" [margin]="0"
                          translate="no"></qrcode>
                        <h5 class="mt-2 mb-0" translate="no">{{ ticketCode }}</h5>
                      </div>
                    </div>
                  </div>

                  <p class="infoLine" *ngIf="!ticketDetails.is_entry_expired && !ticketDetails.badge_created_datetime">
                    Show this code at the Entrance Gate.</p>
                </div>
              </div>
            </div>
          </div>

          <div class="cmpInfo d-flex align-items-center mt-3 justify-content-center"
            *ngIf="ticketDetails?.ticket_type_code === 'standard_invite_by_exh'">


            <div class="orgImg">
              <div class="orgimgOuter">
                <img *ngIf="ticketDetails?.invited_by_image_url; else defaultImg"
                  [src]="ticketDetails.invited_by_image_url + '?time=' + epoch_time"
                  onerror="this.src='/assets/images/default-profile-individual.png'" crossorigin="anonymous"
                  alt="User Image" />
                <ng-template #defaultImg>
                  <img src="/assets/images/default-profile-individual.png" alt="Default User Image" />
                </ng-template>
              </div>
            </div>

            <div class="info ms-3">
              <p class="mb-0 font-weight-600">Invitation From</p>
              <h5 class="font-weight-600 mb-0">
                {{ ticketDetails.invited_by_organisation_name }}
              </h5>
            </div>
          </div>


          <div class="mt-3 d-flex justify-content-between align-items-center btnOut"
            *ngIf="!ticketDetails?.is_entry_expired && !ticketDetails?.badge_created_datetime">
            <button type="button" class="shrWp inv" (click)="inviteFriends()">
              <i class="fa fa-envelope me-2"></i>
              <span>Invite Friends</span>
            </button>

            <button type="button" class="shrWp" (click)="shareOnWhatsApp()">
              <img src="/assets/images/whatsapp-update.png" alt="WhatsApp" />Share
            </button>
          </div>

          <div class="space"></div>
          <div class="btnOut foot mt-2"
            *ngIf="canUpgrade && (eventDetails?.allow_to_register === 1 && eventDetails?.event_status !== 'over') && !ticketDetails.badge_created_datetime">
            <p class="text-center mb-2">Are you planning multiple visits?</p>
            <button type="button" class="shrWp upgradeBtn font-weight-600" (click)="upgradeTicketProcess()">
              Upgrade your ticket
            </button>
          </div>
          <div class="badgeIssued foot mt-2"
            *ngIf="ticketDetails.badge_created_datetime && (eventDetails?.allow_to_register === 1 && eventDetails?.event_status !== 'over')">
            <p class="text-center mb-2">Are you planning multiple visits?</p>
            <button type="button" class="shrWp bookTicketBtn font-weight-600" (click)="goToBuyTicket()">
              Book New Ticket
            </button>
          </div>


          <div class="catlogWrapper" *ngIf="eventDetails?.show_digital_catalog" (click)="goToDigitalCatalogue()">
            <img src="/assets/images/go_to_digital_catlog.png" alt="Go To Digital Catalogue" />
          </div>

          <div class="catlogWrapper mt-0" *ngIf="isContestActive">
            <img [src]="isVotingActive 
              ? '/assets/images/me/voting-tile.png' 
              : '/assets/images/ExploreIdeas.png'" alt="Vote Now" (click)="onClickVote()" />
          </div>

          <div class="invSuccess font-weight-600" *ngIf="ticketDetails?.ticket_type_code === 'standard_invite_by_exh'
         && showInviteSuccess
         && (getIsInviteAccepted() === 'accepted')">
            <i class="fa fa-check me-2"></i> Invitation Accepted !
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loadingTemplate>
  <div class="loader-container">
    <app-loader></app-loader>

  </div>
</ng-template>


<!-- Modal -->
<div #upgradeModal class="modal fade selecttickettypeModal" id="selecttickettypeModal">
  <div class="modal-dialog modal-dialog-bottom modal-dialog-scrollable">
    <div class="modal-content">

      <!-- ✅ If payment in progress → show payment UI -->
      <ng-container *ngIf="isPaymentInProgress; else upgradeModalContent">
        <div class="modal-header border-0 pb-0">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="onCloseUpgradeModal()"></button>
        </div>

        <div class="modal-body pt-0">
          <div class="payment-wrapper">
            <div class="payment-card">
              <img src="assets/images/payment-in-progress.png" alt="Payment In Progress" class="payment-illustration" />

              <h2 class="payment-title">Payment in Progress</h2>

              <div class="payment-amount" *ngIf="paymentAmount && paymentAmount > 0">
                ₹{{ paymentAmount }}
              </div>

              <div class="payment-order" *ngIf="paymentOrderId">
                Order ID: <span>{{ paymentOrderId }}</span>
              </div>

              <div class="payment-loader"></div>

              <p class="payment-text">
                We are still processing your payment.<br />
                You will be notified about success or retry<br />
                within the next 5 minutes.
              </p>

              <button type="button" class="btn btn-outline-secondary w-100 mt-3" data-bs-dismiss="modal"
                (click)="onCloseUpgradeModal()">
                Close
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- ✅ Upgrade UI -->
      <ng-template #upgradeModalContent>

        <!-- ✅ Use flex layout: body scrolls, footer stays bottom -->
        <div class="modal-body pt-4 modal-body-scroll">
          <div class="text-center head">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            <span class="star"><i class="fa fa-star"></i></span>
          </div>

          <h3 class="text-center mt-3 mb-2 font-weight-600">Upgrade your ticket</h3>

          <p class="text-center">
            Visit the event multiple times.<br />
            Pay only the difference amount.
          </p>

          <!-- ✅ show upgrade UI only if canUpgrade -->
          <ng-container *ngIf="canUpgrade; else cannotUpgradeTpl">
            <div class="ticket-list mt-4">
              <div class="ticket mb-3" *ngFor="let opt of visibleUpgrades; trackBy: trackByCode" [ngStyle]="{
                  border:
                    selectedUpgrade?.code === opt.code
                      ? '2px solid ' + ticketColorsModal[opt.code].primary
                      : '1px solid #acacac',
                  background:
                    selectedUpgrade?.code === opt.code
                      ? ticketColorsModal[opt.code].secondary
                      : '#fff',
                  '--after-border-color':
                    selectedUpgrade?.code === opt.code
                      ? ticketColorsModal[opt.code].primary
                      : '#acacac',
                  '--before-border-color':
                    selectedUpgrade?.code === opt.code
                      ? ticketColorsModal[opt.code].primary
                      : '#acacac'
                }" (click)="onSelectUpgrade(opt)" role="button" tabindex="0"
                [attr.aria-pressed]="selectedUpgrade?.code === opt.code">
                <div class="container text-center p-0">
                  <div class="row">
                    <div class="col-8 col-sm-8">
                      <div class="type-wrapper d-flex">
                        <h6 [ngStyle]="{
                            color:
                              selectedUpgrade?.code === opt.code
                                ? ticketColorsModal[opt.code].primary
                                : '#585858'
                          }" class="tkt-type mb-0 mt-2 font-weight-600" translate="no">
                          {{ opt.app_display_name || opt.name }}
                        </h6>

                        <img *ngIf="opt.code" class="tkt-icon ms-2 mt-1" [src]="
                            selectedUpgrade?.code === opt.code
                              ? ticketsImagesBeforeSelecteingc[opt.code].color
                              : ticketsImagesBeforeSelecteingc[opt.code].black
                          " [alt]="(opt.app_display_name || opt.name) + ' icon'" />
                      </div>

                      <div class="price d-flex align-items-center mb-2">
                        <span class="price-text font-weight-600" translate="no">
                          ₹{{ (opt.display_price || 0) - (opt.applied_total_discount || 0) }}
                        </span>

                        <del class="discount-text ms-2" *ngIf="(opt.applied_total_discount || 0) > 0" translate="no">
                          ₹{{ opt.display_price || 0 }}
                        </del>
                      </div>
                    </div>

                    <div class="col-4 col-sm-4 ps-0">
                      <div class="check-badge">
                        <label>
                          <input type="radio" name="upgradeRadio" [checked]="selectedUpgrade?.id === opt.id"
                            (change)="onSelectUpgrade(opt)" aria-label="Select this pass" />
                          <span [ngStyle]="{
                              border:
                                selectedUpgrade?.code === opt.code
                                  ? '2px solid ' + ticketColorsModal[opt.code].primary
                                  : '1px solid #acacac',
                              background:
                                selectedUpgrade?.code === opt.code
                                  ? ticketColorsModal[opt.code].primary
                                  : '#ffffff'
                            }" class="mark" aria-hidden="true"></span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="inst">
                    <ul class="list mb-0 ps-0">
                      <li [ngStyle]="{
                          color:
                            selectedUpgrade?.code === opt.code
                              ? ticketColorsModal[opt.code].primary
                              : '#585858'
                        }" class="list-item border-0 p-0">
                        <i class="fa fa-circle-info me-2"></i>
                        {{ opt.register_instructions || opt.ticket_note || '—' }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="billing_details mt-4 pt-2">
              <div class="bil_title font-weight-600 mb-2">Bill Details</div>
              <div class="details p-3">
                <div class="d-flex justify-content-between align-items-center">
                  <span>MRP total</span>
                  <span translate="no">{{ mrpTotal | currency: 'INR':'symbol-narrow':'1.0-0' }}</span>
                </div>

                <div class="d-flex justify-content-between align-items-center">
                  <span>Discounts</span>
                  <span class="disc green" translate="no">
                    - {{ totalDiscounts | currency: 'INR':'symbol-narrow':'1.0-0' }}
                  </span>
                </div>

                <div class="d-flex justify-content-between align-items-center">
                  <span>Already Paid</span>
                  <span class="disc green" translate="no">
                    - {{ (ticketDetails.paid_amount || 0) | currency: 'INR':'symbol-narrow':'1.0-0' }}
                  </span>
                </div>

                <div class="d-flex justify-content-between align-items-center total" *ngIf="selectedUpgrade">
                  <span class="font-weight-600">
                    Amount to Pay <small>(Includes GST)</small>
                  </span>
                  <span class="font-weight-600" translate="no">
                    {{ amountToPay | currency: 'INR':'symbol-narrow':'1.0-0' }}
                  </span>
                </div>
              </div>
            </div>

            <div class="saving text-center mt-3" translate="no">
              <img class="me-2" src="/assets/images/saving.gif" alt="Saving" />
              You are saving a total of {{ totalDiscounts | currency: 'INR':'symbol-narrow':'1.0-0' }}
            </div>
          </ng-container>

          <!-- ✅ shown when canUpgrade is false -->
          <ng-template #cannotUpgradeTpl>
            <div class="text-center mt-3">
              <p class="mb-2">Upgrade is not available for this ticket right now.</p>
              <button type="button" class="btn btn-outline-secondary w-100" data-bs-dismiss="modal">
                Close
              </button>
            </div>
          </ng-template>

        </div>

        <!-- ✅ Footer stays at bottom + visible ONLY if canUpgrade -->
        <ng-container *ngIf="canUpgrade">
          <div class="mFoot mFoot--sticky d-flex align-items-center justify-content-between px-3">
            <div class="price green">
              <h1 class="fw-bold mb-0" translate="no">
                {{ selectedUpgrade ? (amountToPay | currency: 'INR':'symbol-narrow':'1.0-0') : ('—') }}
              </h1>
              <p class="mb-0">Total Amount</p>
            </div>

            <div>
              <button type="button" class="selectBtn" (click)="onPayHandler()"
                [disabled]="!selectedUpgrade || isPaymentInProgress">
                Pay <i class="fa fa-caret-right"></i>
              </button>

              <p class="text-center my-1 term">
                I accept the
                <a target="_blank" href="https://pune.kisan.in/terms-conditions#digital">terms and conditions</a>
              </p>
            </div>
          </div>
        </ng-container>

      </ng-template>
    </div>
  </div>
</div>


<!-- Payment Success Modal -->
<div #PaymentSuccessModal class="modal" id="paymentSuccessModal" tabindex="-1"
  aria-labelledby="PaymentSuccessModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content green">
      <div class="text-end">
        <button type="button" class="btn" data-bs-dismiss="modal"><i class="fa-solid fa-xmark green"></i></button>
      </div>
      <div class="modal-body text-center mt-3">
        <h1 class="mb-0 fw-bold"><span>Congrats!</span> </h1>
        <h3 class="mt-3"> Ticket upgraded <br> Successfully.</h3>
        <img class="mb-3" src="/assets/images/Upgrade2.gif" />
        <p class="mb-4">
          You have saved
          <span class="amt font-weight-600 ms-1 amount-only" translate="no">
            {{ (totalDiscounts ) | number:'1.0-0':'en-IN' }}
          </span>
        </p>
        <button class="font-weight-600 mt-3" data-bs-dismiss="modal">View Tickets</button>
      </div>
    </div>
  </div>
</div>